import { useEffect, useRef, useState } from 'react';
import { Pagination } from '../model/pagination';
import { useFeedback } from './use-feedback';

// Carrega a grade paginada no servidor a cada searchTrigger; reload mantém os filtros e a página da última consulta
export function usePagedList<TParams extends { page?: number }, TRow>(
    load: (parameters: TParams) => Promise<Pagination<TRow>>,
    parameters: TParams,
    searchTrigger: number | undefined,
    errorMessage: string,
) {
    const { showError } = useFeedback();
    const [response, setResponse] = useState<Pagination<TRow>>(new Pagination<TRow>());
    const [loading, setLoading] = useState(true);
    const current = useRef<TParams>(parameters);

    async function fetch(next: TParams) {
        current.current = next;
        setLoading(true);
        try {
            setResponse(await load(next));
        } catch (error: any) {
            showError(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetch(parameters);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTrigger]);

    function reload() {
        return fetch(current.current);
    }

    return { rows: response.items || [], rowCount: response.totalRecords || 0, loading, reload };
}
